<template>
  <th
    v-if="field.sortable"
    class="t-table__head"
    :class="classes"
    @click.prevent="sort(desc ? 'asc':'desc', field.key)"
  >
    <slot>
      <div class="t-table-v2__head__inner">
        <span>{{ field.label }}</span>
        <t-table-v2-sortable
          v-if="field.sortable"
          :desc="desc"
        />
      </div>
    </slot>
  </th>
  <th
    v-else
    class="t-table__head"
    :class="classes"
  >
    <slot/>
  </th>
</template>

<script>
import TableCellMixin from '../../mixins/TableCellMixin';
import TTableV2Sortable from './TTableV2Sortable.vue';

export default {
  name: 't-table-v2-head',
  mixins: [TableCellMixin],
  components: { TTableV2Sortable },
  inject: ['$expanded'],
  props: {
    field: {
      type: Object,
      required: false,
      default: null,
    },
    orderBy: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    expanded() {
      return this.$expanded();
    },
    desc() {
      return this.orderBy === `-${this.field.key}`;
    },
    classes() {
      const classes = [`t-table-v2__head--${this.contentAlign}`];

      if (this.field.sortable) {
        classes.push('t-table-v2__head--sortable');
      }

      if (this.expanded) {
        classes.push('t-table-v2__head--expanded');
      }

      return classes;
    },
  },
  methods: {
    sort(key, direction) {
      this.$emit('sort', key, direction);
    },
  },
};
</script>
